(function() {

  /* ====================================================
     PROLIFIC FABRIC — CRO ENHANCEMENTS v2
  ==================================================== */

  // ── 1. INJECT CRO CSS ──────────────────────────────
  const style = document.createElement('style');
  style.id = 'pf-cro-styles';
  style.textContent = `

    @keyframes pf-btn-shimmer {
      0%   { background-position: -200% center; }
      100% { background-position: 200% center; }
    }
    .btn--add-to-cart {
      background: linear-gradient(90deg, #111 40%, #333 50%, #111 60%) !important;
      background-size: 200% auto !important;
      animation: pf-btn-shimmer 3s linear infinite !important;
      color: #fff !important;
    }
    .btn--add-to-cart:hover {
      animation: none !important;
      background: #333 !important;
      color: #fff !important;
      transform: scale(1.02);
    }
    .product__badge--sale {
      background: #e74c3c !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 4px !important;
      font-size: 11px !important;
    }
    .announcement p, .announcement span, .ticker__item {
      font-weight: 700 !important;
      letter-spacing: 0.5px !important;
    }
    .card__name, .card__title, .product__card__title {
      font-weight: 700 !important;
    }
    .variant__countdown--low {
      color: #c0392b !important;
      font-weight: 700 !important;
    }
    @media (max-width: 749px) {
      .product__title h1, h1.product__title {
        font-size: 20px !important;
        font-weight: 900 !important;
      }
      .product__price .accent-size-5 {
        font-size: 22px !important;
        font-weight: 700 !important;
      }
    }
    .product__price [data-product-price] { color: #e74c3c !important; font-weight: 700 !important; }
    .product__price s, .product__price del { color: #999 !important; font-size: 0.85em !important; }
    .card__image img, .product__card__image img {
      transition: transform 0.35s ease !important;
    }
    .card__image:hover img, .product__card__image:hover img {
      transform: scale(1.02) !important;
    }
    .cart__progress-bar, .shipping-bar { border-radius: 4px; font-weight: 700; }
    .pf-delivery-estimate {
      display: flex; align-items: center; gap: 6px;
      margin: 8px 0 12px; font-size: 13px;
      color: #2c7a2c; font-weight: 600;
    }
    .pf-delivery-estimate .pf-de-date { font-weight: 700; }
    #pf-back-to-top {
      position: fixed; bottom: 90px; right: 16px;
      width: 40px; height: 40px;
      background: #111; color: #fff;
      border: none; border-radius: 50%;
      font-size: 18px; cursor: pointer; z-index: 9000;
      display: flex; align-items: center; justify-content: center;
      opacity: 0; pointer-events: none;
      transition: opacity 0.3s ease;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    }
    #pf-back-to-top.visible { opacity: 1; pointer-events: all; }
    #pf-back-to-top:hover { background: #333; }
    .pf-flash-banner {
collection-grid-item      background: #111; color: #fff;
      text-align: center; padding: 10px 16px;
      font-size: 13px; font-weight: 700;
      letter-spacing: 0.5px; margin-bottom: 12px; border-radius: 4px;
    }
    .pf-flash-banner .pf-timer { color: #f0c040; font-size: 15px; }

    /* Fix: product card text color inside dark section */
    .section-collection-tabs.palette--light.bg--neutral .product__grid__title,
    .section-collection-tabs.palette--light.bg--neutral .product__grid__price,
    .section-collection-tabs.palette--light.bg--neutral .product__grid__price *,
    .section-collection-tabs.palette--light.bg--neutral .product__grid__cutline,
    .section-collection-tabs.palette--light.bg--neutra .product__grid__info { color: #111 !important; }
        /* Bold collection list titles (Hoodies, Matching Sets, Tees, Bottoms) */
            .collection-grid-item__title { font-weight: 700 !important; font-size: 36px !important; letter-spacing: 2px !important; }
  `;
  document.head.appendChild(style);

  // ── 2. HIDE LOW SAVE BADGES ────────────────────────
  function hideLowSaveBadges() {
    document.querySelectorAll('.product__badge--sale').forEach(function(b) {
      var m = b.textContent.match(/(\d+)%/);
      if (m && parseInt(m[1], 10) < 5) b.style.display = 'none';
    });
  }

  // ── 3. ESTIMATED DELIVERY DATE ────────────────────
  function addDeliveryEstimate() {
    var wrap = document.querySelector('.product__price__wrap');
    if (!wrap || document.querySelector('.pf-delivery-estimate')) return;
    var today = new Date();
    var min = new Date(today); min.setDate(today.getDate() + 2);
    var max = new Date(today); max.setDate(today.getDate() + 5);
    var fmt = function(d) {
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    };
    var el = document.createElement('div');
    el.className = 'pf-delivery-estimate';
    el.innerHTML = '🚚 Order now — est. delivery <span class="pf-de-date">' + fmt(min) + ' – ' + fmt(max) + '</span>';
    wrap.after(el);
  }

  // ── 4. BACK TO TOP BUTTON ─────────────────────────
  function initBackToTop() {
    if (document.getElementById('pf-back-to-top')) return;
    var btn = document.createElement('button');
    btn.id = 'pf-back-to-top';
    btn.innerHTML = '↑';
    btn.title = 'Back to top';
    document.body.appendChild(btn);
    window.addEventListener('scroll', function() {
      btn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── 5. FLASH SALE COUNTDOWN TIMER ────────────────
  function initFlashSaleTimer() {
    if (!document.querySelector('.template-product')) return;
    if (document.querySelector('.pf-flash-banner')) return;
    var now = new Date();
    var end = new Date(now); end.setHours(23, 59, 59, 0);
    var diff = end - now;
    if (diff <= 0) return;
    var banner = document.createElement('div');
    banner.className = 'pf-flash-banner';
    banner.innerHTML = '⚡ SALE ENDS IN: <span id="pf-timer-display">--:--:--</span> <span class="pf-timer-label">  USE CODE COOL10</span>';
    var form = document.querySelector('.product__inner .shopify-product-form');
    if (form) form.before(banner);
    function tick() {
      var rem = end - new Date();
      if (rem <= 0) { banner.remove(); return; }
      var pad = function(n) { return String(n).padStart(2,'0'); };
      var el = document.getElementById('pf-timer-display');
      if (el) el.textContent = pad(Math.floor(rem/3600000)) + ':' + pad(Math.floor((rem%3600000)/60000)) + ':' + pad(Math.floor((rem%60000)/1000));
    }
    tick(); setInterval(tick, 1000);
  }

  // ── RUN ALL ───────────────────────────────────────
  function runAll() {
    hideLowSaveBadges();
    addDeliveryEstimate();
    initBackToTop();
    initFlashSaleTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
  document.addEventListener('shopify:section:load', runAll);

})();